export const TABLE_LABEL = 'Table organizer';
export const RESET_LABEL = 'Reset to default';
export const COLUMNS_LABEL = 'Columns organizer';
export const HIDE_LABEL = 'Hide all columns';
export const UNHIDE_LABEL = 'Unhide all columns';
